/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_ORDER_STATE_ENTITY_NAME = 'exc.jpmam.v1.JpmamOrder';
export const excJpmamV1JpmamOrderStateEntity = new schema.Entity<ExcJpmamV1JpmamOrderState>(EXC_JPMAM_V1_JPMAM_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'orderId' });

